import { axiosInstance, requestConfig } from 'network/apis';

import { URL_HUB } from 'utils/constants';

export const callClientStatusList = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('get', URL_HUB, `/shop/${shopGuid}/clients/status`, data));
};
